<template>
  <div class="row border-bottom">
    <nav
      class="navbar navbar-static-top white-bg"
      role="navigation"
      style="margin-bottom: 0; width: 100%;"
    >
      <div class="navbar-header">
        <a class="navbar-minimalize minimalize-styl-2 btn btn-primary" href="javascript:void(0)">
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <ul class="nav navbar-top-links navbar-right">
        <li>
          <span class="m-r-sm text-muted welcome-message">{{userDisplayName}}</span>
        </li>
        <li>
          <a @click="doLogout()">
            <i class="fa fa-sign-out"></i> Log out
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
/* eslint-disable */
import * as firebase from "firebase/app";
import "firebase/auth";
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["authUser", "userData"]),
    userDisplayName: function () {
      const type = this.authUser?.claims?.role;
      if (type == "picker") return this.userData?.supermarket?.tradeName;
      if (type == "supermarket") return this.userData?.tradeName;
      return "";
    },
  },
  methods: {
    ...mapMutations(["setUserData", "setAuthUser"]),
    doLogout() {
      firebase.auth().signOut();
      this.setAuthUser(null);
      this.setUserData(null);
      this.$store.dispatch('resetState');
      this.$router.replace("/signin");
    },

    SmoothlyMenu() {
      if (
        !$("body").hasClass("mini-navbar") ||
        $("body").hasClass("body-small")
      ) {
        // Hide menu in order to smoothly turn on when maximize menu
        $("#side-menu").hide();
        // For smoothly turn on menu
        setTimeout(function () {
          $("#side-menu").fadeIn(500);
        }, 100);
      } else if ($("body").hasClass("fixed-sidebar")) {
        $("#side-menu").hide();
        setTimeout(function () {
          $("#side-menu").fadeIn(500);
        }, 300);
      } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $("#side-menu").removeAttr("style");
      }
    },
  },

  mounted() {
    // minimalize menu
    $(".navbar-minimalize").click(function () {
      $("body").toggleClass("mini-navbar");
      this.SmoothlyMenu();
      // SmoothlyMenu();
    });
  },
};
</script>
